export const shorten = (text, maxLen = 7) => {
    if (text.length > maxLen) {
        return `${text.slice(0, maxLen - 3)}...`;
    }
    return text;
};
export const genArray = (size) => {
    return new Array(size).fill("Hello");
};
export const gen2DArray = (rows, cols) => {
    const res = new Array(rows);
    for (let i = 0; i < rows; i++) {
        res[i] = new Array(cols).fill("Hello");
    }
    return res;
};
export const isBlank = (text) => {
    return !text || !text.trim();
};
